import { IProduct } from '@commerce-product-webcomponents/sdk';
import { AprProps } from '@commerce-webcomponents/sdk';
import { AbstractComponentPropTypes } from '../../../cms/registries';

export interface CountdownTimer {
  endTime: string;
  title?: string;
}

export enum CarousalType {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  APointCatalog = 'a_point_catalog',
}

export interface ProductCarousalProps
  extends AbstractComponentPropTypes,
    Omit<AprProps, 'aprContainerKey' | 'pageName'> {
  products?: { productId: string; isBundle: boolean }[];
  aprContainerKey?: string;
  pageName?: string;
  title: string;
  type: string;
  backgroundColor?: string;
  themeColor?: string;
  showProductIdAndSizeComp?: boolean;
  showVariantComp?: boolean;
  showAddToCartButtonComp?: boolean;
  countdownTimer?: CountdownTimer;
  showAddToWishlistComp?: boolean;
}

export interface CarousalItemProps {
  productItem: IProduct;
  type: string;
  showProductIdAndSizeComp?: boolean;
  showVariantComp?: boolean;
  showAddToCartButtonComp?: boolean;
  showAddToWishlistComp?: boolean;
}
export interface ProductCardProps {
  product: string;
}
